document.querySelectorAll('.InputCode').forEach((el) => {
    const inputs = el.querySelectorAll('input');
    const endIndex = inputs.length - 1;
    inputs.forEach((input, i) => {
        const isEnd = endIndex <= i;
       input.addEventListener('focus', () => {
           if(!input.value && i && !inputs[i-1].value) {
               inputs[i-1].focus();
           }
           else {
               input.select();
           }
       });
       input.addEventListener('keydown', (e) => {
           if(e.code === 'Backspace') {
               e.preventDefault();
               input.value = '';
               if(i) {
                   inputs[i-1].focus();
               }
           }
       });
       input.addEventListener('input', (e) => {
           if(e.data) {
               input.value = e.data;
           }
           if(!isEnd) {
               inputs[i+1].focus();
           }
       })
       input.addEventListener('paste', (e) => {
           const val = e.clipboardData.getData('text');
           e.preventDefault();
           val.split('').forEach((str, ii) => {
               if(endIndex >= i+ii) {
                   inputs[i+ii].focus();
                   inputs[i+ii].value = str;
               }
           })
       })
    });
})
